export const getFlexProp = align => {
  const flexPropMapper = {
    left: 'flex-start',
    right: 'flex-end',
    center: 'center',
  };
  return flexPropMapper[align] ? flexPropMapper[align] : 'flex-start';
};
